export default "__VITE_ASSET__8NseCNhY__"